import { render, staticRenderFns } from "./StockListSalesOrders.vue?vue&type=template&id=75f271fb"
import script from "./StockListSalesOrders.vue?vue&type=script&lang=js"
export * from "./StockListSalesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports